import { useEffect, useState } from 'react';
import { User } from 'lucide-react';

const SIZE_CLASS = {
  xs: {
    box: 'w-5 h-5',
    icon: 'w-3 h-3',
  },
  sm: {
    box: 'w-8 h-8',
    icon: 'w-4 h-4',
  },
  md: {
    box: 'w-9 h-9',
    icon: 'w-4 h-4',
  },
} as const;

export function UserAvatarImg({
  avatarUrl,
  name,
  size = 'sm',
  className = '',
  fallbackClassName = '',
}: {
  avatarUrl?: string | null;
  name?: string | null;
  size?: keyof typeof SIZE_CLASS;
  className?: string;
  fallbackClassName?: string;
}) {
  const [broken, setBroken] = useState(false);
  const sizeClass = SIZE_CLASS[size];
  const label = name || 'User';

  useEffect(() => {
    setBroken(false);
  }, [avatarUrl]);

  if (!avatarUrl || broken) {
    return (
      <span
        className={`${sizeClass.box} rounded-full bg-darkbg-tertiary border border-darkbg-border
                    flex items-center justify-center shrink-0 transition-all duration-150
                    ${fallbackClassName || className}`}
        aria-label={label}
        role="img"
      >
        <User className={`${sizeClass.icon} text-parchment-muted`} />
      </span>
    );
  }

  return (
    <img
      src={avatarUrl}
      alt={label}
      className={`${sizeClass.box} rounded-full object-cover shrink-0 transition-all duration-150 ${className}`}
      onError={() => setBroken(true)}
    />
  );
}
